export const getXeroIntegration = (data = []) =>
  data.find(({ integration_type, status }) => integration_type === "xero" && status === "active");
